import { Block } from 'baseui/block';
import { ObjectHeader } from '../components/ObjectHeader'
import { StatusPanelButtonsGroup } from '../components/StatusPanelButtonsGroup'
import { ObjectAlarms } from '../../features/Alarm'
import { GetObjectUrl } from '../../utils/navigationService';
import { Link } from 'react-router-dom';
import { styled, useStyletron } from 'baseui';
import { useEffect, useState } from 'react';
import { getBimId, getPlantId } from '../utils';
import { HasOperatorPanel, IsSmartApp } from '../automationObjectsSelector';
import { IoHandRightOutline } from 'react-icons/io5';
import { themedUseStyletron } from '../../theme/customTheme';


export const OverviewPanelWrapper = (props: any) => {
    const [css, theme] = themedUseStyletron();
    const height = props.height ?? (props.small ? theme.appSizes.smallAppHeight : theme.appSizes.mediumAppHeight);

    /*useEffect(() => {
        if (!props.small && props.small !== undefined)
            setHeight('380px');
    }, [props.small]);*/

    const plantId = getPlantId(props);
    const isSmartApp = IsSmartApp({ tag: props.schema });

    return (
        <MainContainer $height={height}>
          <MyLink {...props}>
            <HeaderContainer>
                <ObjectHeader {...props} PIS={plantId} objectId={props.id}></ObjectHeader>
                <Block display='flex' flexDirection='row' gridGap={theme.sizing.scale100}>
                    {props.isMan && <IoHandRightOutline size={'2em'} color={theme.colors.accent500}></IoHandRightOutline>}
                    {props.actionButtons &&
                        <>{props.actionButtons}</>
                    }
                    {isSmartApp && <>🧠</>}
                </Block>
            </HeaderContainer>

            <ChildrenContainer>
                {props.children}
            </ChildrenContainer>
            </MyLink>
            <FooterContainer>
                <ObjectAlarms includeAlarmsFromChildren={props.includeAlarmsFromChildren} resourceGroupId={props.resourceGroupId} id={props.id}></ObjectAlarms>

                <StatusPanelButtonsGroup app={props}></StatusPanelButtonsGroup>
            </FooterContainer>
        </MainContainer >

    )
}
const MainContainer = styled<'div', { $height: any }>("div", ({ $height, $theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    minHeight: $height,
    alignItems: 'stretch',
    justifyContent: 'space-between',
}));

const ChildrenContainer = styled("div", ({ $theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flex: '1 1 auto',
    marginTop: $theme.sizing.scale200,
    gap: $theme.sizing.scale200
}));

const FooterContainer = styled("div", ({ $theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: $theme.sizing.scale200,
}));



const HeaderContainer = styled("div", ({ $theme }) => ({
    //flex: '0 0 auto',
    display: 'flex', 
    flexDirection: 'row',
    justifyContent: 'space-between'
}));

const MyLink = (props: any) => {
    const [css, theme] = useStyletron();
    const [url, setUrl] = useState('')
    const hasUrl = props.resourceGroupId && props.id;
    const [isHover, setIsHover] = useState(false);
    const hasOperatorPanel = HasOperatorPanel({ tag: props.schema });



    const handleMouseEnter = () => setIsHover(true);
    const handleMouseLeave = () => setIsHover(false);

    useEffect(() => {
        setUrl(props.url ? props.url : GetObjectUrl(props.resourceGroupId, props.id));
    }, [props.url, props.resourceGroupId, props.id]);

    const linkStyle = isHover ? { textDecoration: 'none', opacity: 0.7, color: theme.colors.contentPrimary } : { textDecoration: 'none', color: theme.colors.contentPrimary }

    if (!hasOperatorPanel)
        return (<>{props.children}</>)


    if (!hasUrl)
        return <>{props.children}</>

    return (
        <Link to={url} className={css(linkStyle)}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}>
            {props.children}
        </Link>
    )
}



/*
<Block gridRowGap={theme.sizing.scale400} justifyContent='space-evenly' display='flex' flexDirection='column' alignItems='center'>
                        {props.children}
                    </Block>
                    */